import axios from 'axios';
import SITE_SETTINGS from 'src/constants/whiteLabel';

const baseURL =
    SITE_SETTINGS.apiV2[process.env.REACT_APP_NODE_ENV || 'development'];

export const ApiV2 = axios.create({
    baseURL,
});
